<template>
  <div class="flex flex-col">
    <div class="signature-button" :style="styleObject"></div>
    <template v-if="isActive">
      <div
        ref="shortLabelElement"
        contenteditable="true"
        class="short-label font-inter cursor-text border-0 bg-transparent p-0 text-sm shadow-none focus:outline-none"
        :data-placeholder="t('common.shortLabelPlaceholder')"
        @blur="updateShortLabel"
        @input="
          (e) => {
            shortLabel = (e.target as HTMLElement).textContent;
            updateShortLabel();
            handleSafariCursor(e);
          }
        "
        @keydown="handleSafariCursor"
        @click="(e) => e.stopPropagation()"
        @focus="(e) => e.stopPropagation()"
        v-text="shortLabel"
      ></div>
    </template>
    <template v-else>
      <span v-if="element.shortLabel" class="short-label font-inter break-words text-sm">{{
        element.shortLabel
      }}</span>
    </template>
  </div>
</template>

<script setup lang="ts">
import { fixSafariCursor } from "@/util/methods";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  element: {
    type: Object,
    default: () => {
      return {};
    },
  },
  styleObject: {
    type: Object,
    default: () => {
      return {};
    },
  },
  isActive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:shortLabel"]);
const shortLabel = ref(props.element.shortLabel || "");
const shortLabelElement = ref<HTMLElement | null>(null);
const { t } = useI18n();

// Handler method to call the fixSafariCursor function
const handleSafariCursor = (e: Event) => {
  const isKeyDown = e.type === "keydown";
  fixSafariCursor(e, isKeyDown);
};

watch(
  () => props.element.shortLabel,
  (newVal) => {
    shortLabel.value = newVal || "";
  }
);

const updateShortLabel = () => emit("update:shortLabel", shortLabel.value);
</script>
<style scoped>
.signature-button {
  border: 1px solid #ccc;
  height: 160px;
  width: 100%;
  border-radius: 4px;
}
.short-label {
  margin-top: 8px;
  font-size: 14px;
  color: #4b5563;
}

.short-label:empty:before {
  content: attr(data-placeholder);
}
</style>
